import * as React from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../../theme";
import { useTheme } from "@material-ui/styles";
import CameraCard from "./CameraCard";
import CameraSummary from "./CameraSummary";
import { CameraHook } from "../../../hooks/useCameras";
import { CameraOptionsHook } from "../../../hooks/useCameraOptions";
import { overallRisk } from "./measurementRisk";
import CameraSummaryHeadings from "./CameraSummaryHeadings";
import { RISK_WEIGHTS } from "../../../constants/matrix";

const DEFAULT_WEIGHTS = RISK_WEIGHTS;

const StyledSection = styled.section`
  border-radius: 5px;
  overflow: scroll;
  flex: 1;

  ${({ theme }: { theme: Theme }) => {
    return css``;
  }};
`;

export interface CameraContentProps {
  cameraHook: CameraHook;
  cameraOptionsHook: CameraOptionsHook;
}

const CameraContent: React.FC<CameraContentProps> = props => {
  const { cameraHook, cameraOptionsHook } = props;
  const {
    deployments,
    liveState,
    startIndex,
    reducedValues,
    pastState,
    pastReducedValues,
  } = cameraHook.data;
  const {
    riskFilter,
    siteFilter,
    live,
    listViewOn,
  } = cameraOptionsHook.options;
  const theme: Theme = useTheme();

  //Get the visible cameras
  const visibleCameras = deployments
    //Fitler by site name
    .filter(deployment => {
      if (siteFilter) {
        if (!deployment.site) return false;
        return deployment.site!.siteName === siteFilter;
      } else return true;
    })
    //Filter by risk category
    .filter(deployment => {
      if (riskFilter) {
        return (
          overallRisk(liveState[deployment.deploymentId], DEFAULT_WEIGHTS)
            .val === riskFilter
        );
      } else return true;
    })
    //Sort by risk category (Higher risk shows first)
    .sort((a, b) => {
      const stateA = liveState[a.deploymentId];
      const stateB = liveState[b.deploymentId];
      if (stateA && stateB) {
        const riskA = overallRisk(stateA, DEFAULT_WEIGHTS).val;
        const riskB = overallRisk(stateB, DEFAULT_WEIGHTS).val;
        return riskB - riskA; //Sort in descending order
      } else {
        return 0; //If either stateA and stateB dont exist then dont sort
      }
    })
    //#ff0 temporary change TO REMOVE LIDAR
    .filter(v => v.deploymentId !== 4);

  return (
    <>
      <StyledSection theme={theme}>
        {listViewOn &&
          visibleCameras.map(d => (
            <CameraCard
              key={d.deploymentId}
              deployment={d}
              liveState={
                live ? liveState[d.deploymentId] : pastState[d.deploymentId]
              }
              startIndex={live ? startIndex : 0} //dont set an index if data not live
              reducedState={
                live
                  ? reducedValues[d.deploymentId]
                  : pastReducedValues[d.deploymentId]
              }
              options={cameraOptionsHook.options}
            />
          ))}
        {!listViewOn && <CameraSummaryHeadings />}
        {!listViewOn &&
          visibleCameras.map(d => (
            <CameraSummary
              deployment={d}
              liveState={liveState[d.deploymentId]}
              options={cameraOptionsHook.options}
            />
          ))}
      </StyledSection>
    </>
  );
};

export default CameraContent;
